import { CloudOff } from 'lucide-react';

/** Inline empty-state stand-in shown when a screen's live view can't be reached. */
export default function ReconnectingNotice() {
  return (
    <span
      className="inline-flex items-center gap-2 text-orange"
      data-testid="reconnecting-notice"
      role="status"
      aria-live="polite"
    >
      <CloudOff size={14} className="shrink-0" />
      Can&rsquo;t reach the server — retrying…
    </span>
  );
}
